import { Component } from '@angular/core';
import { EmdmIcons } from 'src/app/services/appicons.service';

@Component({
  selector: 'app-acd-create',
  standalone: false,
  templateUrl: './acd-create.component.html',
  styleUrl: './acd-create.component.scss'
})
export class AcdCreateComponent {
  constructor(private iconPacks: EmdmIcons) {}
  
  backbtn = this.iconPacks.FaCircleArrowLeft;
}
